// src/components/usuarios/UserManagement.jsx

import React, { useState, useEffect } from 'react';
// Importa los iconos que necesitas
import { FiSearch, FiMoreVertical, FiChevronLeft, FiChevronRight, FiEdit2, FiTrash2 } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
// Importa el archivo SCSS único para esta vista
import '../../assets/scss/usuarios/_user-management.scss';

const UserManagement = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [recordsPerPage, setRecordsPerPage] = useState(3);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  const recordsPerPageOptions = [3, 6, 9, 12];

  useEffect(() => {
    const endpoint = 'http://localhost:3004/users';

    const fetchUsers = async () => {
      try {
        const response = await fetch(endpoint, {
          headers: {
            'Content-Type': 'application/json',
            // Si usas autenticación, agrega aquí el token
            // 'Authorization': `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error('Error al obtener usuarios');
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        // Puedes mostrar un mensaje de error aquí si lo deseas
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleRecordsPerPageChange = (e) => {
    const newRecordsPerPage = parseInt(e.target.value);
    setRecordsPerPage(newRecordsPerPage);
    setCurrentPage(1); // Reset to first page when changing records per page
  };

  // --- Lógica de Toggle, Filtro y Paginación ---
  const handleToggle = (userId) => {
    setUsers(currentUsers =>
      currentUsers.map(user =>
        user.id === userId ? { ...user, active: !user.active } : user
      )
    );
  };

  const filteredUsers = users.filter(user =>
    (user.name?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (user.email?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (user.role?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
    (user.location?.toLowerCase() || '').includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredUsers.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredUsers.slice(indexOfFirstRecord, indexOfLastRecord);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    const maxButtons = 5;
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + maxButtons - 1);

    if (end - start + 1 < maxButtons) {
      start = Math.max(1, end - maxButtons + 1);
    }

    for (let i = start; i <= end; i++) {
      buttons.push(
        <button
          key={i}
          className={`pagination__btn ${currentPage === i ? 'pagination__btn--active' : ''}`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>
      );
    }

    return buttons;
  };
  // --- Fin Lógica ---

  const handleNewUser = () => {
    navigate('/usuarios/nuevo');
  };
// editar usuario
  const handleSave = async () => {
    try {
      const response = await fetch(`http://localhost:3004/users/${formData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error('Error al actualizar usuario');
      // Opcional: redirige o muestra mensaje de éxito
    } catch (error) {
      alert('No se pudo actualizar el usuario. Intenta de nuevo.');
    }
  };
  //endpoint eliminar usuario

  const handleDeleteUser = async () => {
    if (!userToDelete) return;
    try {
      const response = await fetch(`http://localhost:3004/users/${userToDelete.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${token}`, // Si usas autenticación
        },
      });
      if (!response.ok) throw new Error('Error al eliminar usuario');
      setUsers(users.filter(u => u.id !== userToDelete.id));
    } catch (error) {
      alert('No se pudo eliminar el usuario. Intenta de nuevo.');
    } finally {
      setShowDeleteModal(false);
      setUserToDelete(null);
    }
  };

  if (loading) {
    return <div>Cargando usuarios...</div>;
  }

  return (
    <div className="user-management-view">
      <h1 className="user-management-view__title">Usuarios</h1>

      <div className="user-card">
        <div className="user-card__main-header">
          <h2 className="user-card__main-title">Usuarios</h2>
          <button className="um-btn um-btn--primary" onClick={handleNewUser}>
            Nuevo usuario
          </button>
        </div>

        <div className="user-card__content">
          <div className="user-card__section-header">
            <h3 className="user-card__subtitle">Registro de usuarios</h3>
            <p className="user-card__description">
              En esta sección podrás visualizar, duplicar, editar, activar los usuarios.
            </p>
          </div>

          <div className="search-bar">
            <FiSearch className="search-bar__icon" />
            <input
              type="search"
              placeholder="Buscar en registro de usuarios"
              className="search-bar__input"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>

          <div className="user-table-wrapper">
            <table className="user-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Usuario</th>
                  <th>Puesto</th>
                  <th>Ubicación</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {currentRecords.length > 0 ? currentRecords.map(user => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.role}</td>
                    <td>{user.location}</td>
                    <td>
                      <div className="user-table__actions" style={{ position: 'relative' }}>
                        <div
                          className={`toggle-switch ${user.active ? 'toggle-switch--active' : ''}`}
                          onClick={() => handleToggle(user.id)}
                          role="switch"
                          aria-checked={user.active}
                        />
                        <button className="more-options-btn"
                        onClick={() => setOpenMenuId(openMenuId === user.id ? null : user.id)} 
                        >
                          <FiMoreVertical />
                        </button>
                        {openMenuId === user.id && (
                          <div className="options-menu">
                            <button
                              className="options-menu__item"
                              onClick={() => {
                                navigate(`/usuarios/editar/${user.id}`);
                                setOpenMenuId(null);
                              }}
                            >
                              <FiEdit2 style={{ marginRight: 8 }} /> Editar
                            </button>
                            <button
                              className="options-menu__item options-menu__item--danger"
                              onClick={() => {
                                setUserToDelete(user);
                                setShowDeleteModal(true);
                                setOpenMenuId(null); // Cierra el menú
                              }}
                            >
                              <FiTrash2 style={{ marginRight: 8 }} /> Eliminar
                            </button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center', padding: '1.5rem 1rem', color: 'var(--text-light)' }}>
                      No se encontraron usuarios {searchTerm ? 'que coincidan con la búsqueda' : ''}.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 0 && (
            <div className="pagination">
              <div className="pagination__records">
                <span>Registros por página:</span>
                <select
                  value={recordsPerPage}
                  onChange={handleRecordsPerPageChange}
                  aria-label="Seleccionar registros por página"
                >
                  {recordsPerPageOptions.map(option => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div className="pagination__controls">
                <button
                  className={`pagination__btn ${currentPage === 1 ? 'pagination__btn--disabled' : ''}`}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <FiChevronLeft />
                </button>
                {renderPaginationButtons()}
                <button
                  className={`pagination__btn ${currentPage === totalPages ? 'pagination__btn--disabled' : ''}`}
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <FiChevronRight />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {showDeleteModal && (
        <div className="modal-backdrop-custom">
          <div className="modal-custom">
            <h3>¿Estás seguro?</h3>
            <p>
              Esto eliminará cualquier contenido adjunto a este usuario. Esta acción no se puede deshacer.
            </p>
            <div className="modal-custom__actions">
              <button
                className="um-btn"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancelar
              </button>
              <button
                className="um-btn um-btn--danger"
                onClick={handleDeleteUser}
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
